export default {
  toolbar: [
    { name: "basicstyles", items: ["Bold", "Italic", "Underline"] },
    { name: "paragraph", items: ["NumberedList", "BulletedList"] },
    { name: "insert", items: ["Image", "Table"] },
    { name: "document", items: ["Source"] },
  ],
  coreStyles_bold: { element: "b" }, // Use <b> instead of <strong>
  coreStyles_italic: { element: "i" }, // Use <i> instead of <em>
};
